import { useMutation } from '@provision/graphql-client';
import { SAVE_ACTIVATION_FLOW_CONFIG_BUNDLE_MUTATION } from 'src/graphql/entities/activation-flow-config/activation-flow-config.operations';
import type {
  SaveActivationFlowConfigBundleMutationData,
  SaveActivationFlowConfigBundleMutationVariables,
} from 'src/graphql/entities/activation-flow-config/activation-flow-config.types';

export const useSaveActivationFlowConfigBundle = () => {
  const [saveActivationFlowConfigBundle, { data, loading, error }] = useMutation<
    SaveActivationFlowConfigBundleMutationData,
    SaveActivationFlowConfigBundleMutationVariables
  >(SAVE_ACTIVATION_FLOW_CONFIG_BUNDLE_MUTATION);

  return {
    saveActivationFlowConfigBundle,
    data,
    loading,
    error,
  };
};
